<template>
  <div
    v-if="isShowPopup"
    class="modal fade show d-block"
    tabindex="-1"
    role="dialog"
    @click.self="closeOnBackdropClick && modalCallBack(false)"
  >
    <div
      :class="[
        'modal-dialog',
        sizeClass,
        { 'modal-dialog-centered': centered },
      ]"
    >
      <div class="modal-content">
        <!-- Header -->
        <div class="modal-header text-white" :class="themeClass">
          <slot name="header">
            <!-- Header -->
            <p v-if="modalTitle" class="text-white font-weight-bold h5">
              {{ modalTitle }}
            </p>
          </slot>
          <button
            v-if="closeOnBackdropClick"
            type="button"
            class="close text-white"
            @click="modalCallBack(false)"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <!-- Body -->
        <div class="modal-body">
          <slot name="body">
            <p v-if="modalContent">
              {{ modalContent }}
            </p>
            <!-- Body Content -->
          </slot>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <hr />
          <slot name="footer">
            <button
              v-for="(btn, index) in buttons"
              :key="index"
              class="modal-btn btn text-white"
              :style="getButtonStyle(btn.type)"
              @click="modalCallBack(btn)"
            >
              {{ btn.label }}
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isShowPopup: {
      type: Boolean,
      default: false,
    },
    modalTitle: {
      type: String,
      default: "",
    },
    modalContent: {
      type: String,
      default: "",
    },
    buttons: {
      type: Array,
      default: () => [
        { label: "Cancel", type: "secondary" },
        { label: "Confirm", type: "primary" },
      ],
    },
    theme: {
      type: String,
      default: "default",
    },
    customGradient: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: "md",
      validator: (value) => ["sm", "md", "lg", "xl"].includes(value),
    },
    closeOnBackdropClick: {
      type: Boolean,
      default: true,
    },
    centered: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    sizeClass() {
      return {
        sm: "modal-sm",
        md: "",
        lg: "modal-lg",
        xl: "modal-xl",
      }[this.size];
    },
    themeClass() {
      if (this.theme == "default") {
        return "bg-primary";
      } else {
        return this.customGradient ? "" : `gradient-${this.theme}`;
      }
    },
    customGradientStyle() {
      return this.customGradient
        ? {
            background: this.customGradient,
            backgroundBlendMode: "exclusion, normal",
          }
        : {};
    },
  },
  methods: {
    modalCallBack(action) {
      if (action?.value !== undefined && action?.value !== null) {
        this.$emit("modalCallBack", action.value);
      } else if (action?.label) {
        this.$emit("modalCallBack", action.label);
      } else {
        this.$emit("modalCallBack", action);
      }
    },
    getButtonStyle(type) {
      const colors = {
        tfw_primary: "#ff00ff",
        primary: "#dd3651",
        secondary: "#9f9f9f",
      };

      return {
        background: colors[type] || colors.primary,
      };
    },
  },
};
</script>

<style scoped>
.modal.fade.show {
  background: rgba(0, 0, 0, 0.5);
  overflow-x: hidden;
  overflow-y: auto;
}

.modal-dialog {
  margin: 1.75rem auto;
}
.close {
  font-size: 1.5rem;
  border: none;
  background: transparent;
  cursor: pointer;
}

.modal-body {
  font-size: 15px;
  font-weight: 400;
}

.modal-header {
  min-height: 50px;
}

/* Modal Content Theme Classes */
.gradient-tfm-primary {
  background: linear-gradient(292deg, #9320f2, #4c34e9 50.45%, #18abf9);
  background-blend-mode: exclusion, normal;
}

.gradient-secondary {
  background: linear-gradient(135deg, #ff8a00, #e52e71);
  background-blend-mode: exclusion, normal;
}

.modal-footer .modal-btn {
  width: 110px;
  height: 45px;
  border-radius: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  transition: all 0.3s ease-in-out;
}

@media (max-width: 576px) {
  .modal-dialog {
    margin: 0.5rem;
    max-width: calc(100% - 1rem);
  }
  
  .modal-content {
    max-height: calc(100vh - 1rem);
    display: flex;
    flex-direction: column;
  }
  
  .modal-body {
    overflow-y: auto;
    flex: 1;
    max-height: calc(100vh - 200px); 
  }
  
  .modal-header,
  .modal-footer {
    flex-shrink: 0; 
  }
}
</style>
